import Axios from 'axios'
import qs from 'qs'
import { getLanguage } from '../lang'
import { getAccessToken } from '@/lib/business'
import { assembleConfig } from '@/utils/params-encryption'
// import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'
function createAxios(security = false) {
  let axios = null
  if (security) {
    axios = Axios.create({
      // adapter: throttleAdapterEnhancer(
      // 	cacheAdapterEnhancer(getAdapter(Axios.defaults.adapter))
      // ),
      baseURL: process.env.VUE_APP_SERVER_API || `/`,
      timeout: 60 * 1000,
      transformRequest: [
        (data) => {
          return qs.stringify(data, { arrayFormat: 'repeat' })
        },
        ...Axios.defaults.transformRequest
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept-Language': getLanguage()
      }
    })
  } else {
    axios = Axios.create({
      // adapter: throttleAdapterEnhancer(
      // 	cacheAdapterEnhancer(getAdapter(Axios.defaults.adapter))
      // ),
      baseURL: process.env.VUE_APP_SERVER_API || `/`,
      timeout: 60 * 1000,
      headers: {
        'Accept-Language': getLanguage()
      }
    })
  }

  axios.interceptors.request.use((config) => {
    assembleConfig(config)
    config.headers['Accept-Language'] = getLanguage()
    config.headers['Platform'] = process.env.NODE_ENV === 'application' ? 'app' : 'web'
    // 如果是pwa的环境
    if (window.matchMedia('(display-mode: standalone)').matches) {
      config.headers['Platform'] = 'pwa'
    }
    return config
  })
  registerInterceptors(axios)
  return axios
}

function registerInterceptors(axios) {
  axios.interceptors.request.use((config) => {
    if (config.url !== '/user/login/v1') {
      config.headers.token = getAccessToken()
    }
    return config
  })
  axios.interceptors.response.use(
    function (res) {
      if (!res) {
        throw new Error('no data')
      } else if (res.data.code === 201) {
        // if (!getAccessToken()) return res.data
        // // window.isThirdAuthTokenLogin = false
        // if (window.isneedlogin) return res.data
        if (sessionStorage.getItem('assetQuery.token')) {
          window.isThirdAuthTokenLogin = true
        }

        // window.isneedlogin = true
        const ev = new Event('LoginTimeOut')
        window.dispatchEvent(ev)

        return res.data
      } else if (res.data.code !== 0) {
        if (!res.config.headers.silent) {
          if (res.data.msg) {
            const ev = new Event('ShowErrorMessage')
            ev.msg = { text: res.data.msg, type: 'error' }
            window.dispatchEvent(ev)
          }
        }

        return res.data
      } else {
        if (res.config.url === '/user/logout') {
          localStorage.clear()
          sessionStorage.clear()
        }

        if (res.config.url === '/user/login/v1') {
          localStorage.setItem('accessToken', res.headers.token)
          // // window.open('http://192.168.199.10:8102/index?assetToken=' + res.headers.token, '_self')
          // window.open('http://user-1.hcs55.com:38080/index?assetToken=' + res.headers.token, '_self')
        }
        if (res.data.code !== undefined) {
          return res.data
        }
        return res.data.data
      }
    },
    function (error) {
      if (!Axios.isCancel(error) && error.code !== 'ECONNABORTED') {
        const ev = new Event('ShowErrorMessage')
        ev.msg = { text: error.message, type: 'error' }
        window.dispatchEvent(ev)
      }
      console.error(error)
      throw error
    }
  )
}

const securityAxios = createAxios(true)
const axios = createAxios(false)

export { axios, securityAxios }
